/*
 * @Author: bbqin
 * @Date: 2022-03-31 14:07:41
 * @LastEditTime: 2022-03-31 14:44:58
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\Tree\TreeNodeToolTip.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component } from "react";
import { Tooltip } from '@platform/base';

class TreeNodeToolTip extends Component {
    state = { visible: false }

    //使用控制弹出层显示时的钩子函数
    onVisibleChange = () => {
        console.log('visible changed.');
    }

    render() {
        let { children, ...others } = this.props;
        let { visible } = this.state;

        return <Tooltip
            placement="top"
            visible={visible}
            onVisibleChange={this.onVisibleChange}
            delayHide={1}
            delayShow={1}
            // overlayStyle={{ marginTop: '-10px' }}
            {...others}
        >
            <span
                onMouseEnter={e => {
                    this.setState({ visible: true });
                }}
                onMouseLeave={e => {
                    this.setState({ visible: false });
                }}
            >
                {children}
            </span>
        </Tooltip>;
    }
}

export default TreeNodeToolTip;